<script>
import { mapActions, mapState } from 'vuex';
import { map } from 'lodash-es';
import store from '../../../store';

export default {
  name: 'SkiPassSeasonArea',
  data: () => ({
    returnObject: true,
  }),
  computed: {
    ...mapState({
      season: state => state.skipass.season,
      skiAreas: state => state.skipass.season.skiAreas.items,
      areasLoading: state => state.skipass.season.skiAreas.itemsLoading,
      areasError: state => state.skipass.season.skiAreas.itemsError,
      areasSaveLoading: state => state.skipass.season.skiAreas.saveLoading,
      areasSaveError: state => state.skipass.season.skiAreas.saveError,
      availableAreas: state => state.areas.areas.items,
      availableAreasLoading: state => state.areas.areas.itemsLoading,
      availableAreasError: state => state.areas.areas.itemsError,
    }),
    selectedSkiAreasMapped() {
      return map(this.skiAreas, area => ({
        id: area.id,
        name: area.name,
      })).sort((a, b) => a.name.localeCompare(b.name));
    },
    availableSkiAreasMapped() {
      return map(this.availableAreas, area => ({
        id: area.id,
        name: area.name.concat(' (').concat(area.country.alias).concat(')'),
      })).sort((a, b) => a.name.localeCompare(b.name));
    },
  },
  methods: {
    ...mapActions({
      loadSkiAreas: 'skipass/areasBySeasonIdLoad',
      loadAvailableAreas: 'areas/fetchAreas',
      areaOnSeasonSave: 'skipass/areaOnSeasonSave',
      areaOnSeasonDelete: 'skipass/areaOnSeasonDelete',
    }),
    syncSelectedToBeAddedOrDeleted(newSelectedAreas) {
      Object.values(this.selectedSkiAreasMapped).forEach((oldArea) => {
        const selectedAreaId = newSelectedAreas.find(newArea => newArea === oldArea.id);
        if (!selectedAreaId) {
          this.areaOnSeasonDelete({ seasonId: this.season.id, areaId: oldArea.id });
        }
      });
      newSelectedAreas.forEach((newAreaId) => {
        const selectedArea = this.selectedSkiAreasMapped.find(oldArea => oldArea.id === newAreaId);
        if (!selectedArea) {
          const newItem = this.availableAreas.find(item => item.id === newAreaId);
          this.areaOnSeasonSave({
            seasonId: this.season.id,
            newItem: {
              id: newItem.id,
              name: newItem.name.concat(' (').concat(newItem.country.alias).concat(')'),
            },
          });
        }
      });
    },
  },
  mounted() {
    if (!this.skiAreas || !this.skiAreas.length) {
      this.loadSkiAreas(this.season.id);
    }
    if (!this.availableAreas || !this.availableAreas.length) {
      this.loadAvailableAreas();
    }
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch('skipass/seasonWithRelationsBySeasonIdLoad', to.params.seasonId)
      .finally(() => {
        next();
      });
  },
};
</script>
<template>
  <v-container class="pa-0 py-2">
    <h2 class="d-inline-block">
      {{ $t('ski.skiSeasonAreas.areasSelected', { total: this.selectedSkiAreasMapped.length }) }}
    </h2>
    <v-btn
      @click="loadSkiAreas(season.id)"
      :loading="areasLoading || availableAreasLoading"
      icon
    >
      <v-icon>cached</v-icon>
    </v-btn>
    <div class="text-center pa-1">
      <v-progress-linear
        v-if="this.areasLoading || this.areasSaveLoading"
        :indeterminate="true"
      />
    </div>
    <v-autocomplete
      @input="syncSelectedToBeAddedOrDeleted"
      :items="this.availableSkiAreasMapped"
      :value="this.selectedSkiAreasMapped"
      :loading="availableAreasLoading || areasLoading"
      :deletable-chips="true"
      :label="$t('ski.skiSeasonAreas.selectOrDeSelected', {
        total: availableSkiAreasMapped.length
      })"
      item-text="name"
      item-value="id"
      class="pa-4"
      chips
      multiple
    />
  </v-container>
</template>



// WEBPACK FOOTER //
// src/pages/ski/skipass/SkiPassSeasonAreas.vue